// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button_WtyL2","outline":"Button_outline_1C5Yo","outlineBlue":"Button_outlineBlue_1jKTL","lightBlue":"Button_lightBlue_2Rcbn","sm":"Button_sm_wi9xY"};